import { bindConnect } from '../../../utils';
import Login from './Login';

export default bindConnect(state => ({
  user: state.current_user.user
}))(Login);
